import _ from 'lodash';
import { $merge, $set, update } from 'qim';

import { createReducer } from '@zapier/toolbox-redux-framework';

import ActionTypes from './ActionTypes';

const INITITAL_ZAP_RUN_MESSAGE = {
  status: 'success',
  body: 'Manually running zap: ',
};

const initialState = {
  // zapId: [messages] transitioning to zapId: [{status: 'success', body: message}].
  zapRunStatusMap: {},
  heldReasons: {
    isLoading: false,
    isLoaded: false,
    total: 0,
  },
  heldTasksBanner: {
    isOpen: false,
  },
};

const handlers = {
  [ActionTypes.RUN_ZAP](state, { zapId }) {
    return update(
      ['zapRunStatusMap', zapId, $set([INITITAL_ZAP_RUN_MESSAGE])],
      state
    );
  },

  [ActionTypes.RUN_ZAP_STATUS_DONE](state, { zapId, result }) {
    // We don't want to lose the message we initialized
    // in RUN_ZAP, so make sure we add it to the beginning here.
    const messages = [INITITAL_ZAP_RUN_MESSAGE].concat(result);
    return update(
      // only need to normalize until backend code ships, then we can
      // set the message without normalizing it.
      ['zapRunStatusMap', zapId, $merge(messages)],
      state
    );
  },

  [ActionTypes.LOAD_HELD_REASONS](state) {
    return update(
      [
        ['heldReasons', 'isLoading', $set(true)],
        ['heldReasons', 'isLoaded', $set(false)],
      ],
      state
    );
  },

  [ActionTypes.LOAD_HELD_REASONS_DONE](state, { result }) {
    const prevSnapshot = state.heldTasksBanner.snapshot;
    const prevIsOpen = state.heldTasksBanner.isOpen;
    const isOpen = _.isEmpty(result) ? false : prevIsOpen;

    const updatedSnapshot = _.isEmpty(result) ? undefined : prevSnapshot;

    return update(
      [
        [
          'heldReasons',
          $set({ total: 0, ...result, isLoading: false, isLoaded: true }),
        ],
        ['heldTasksBanner', 'snapshot', $set(updatedSnapshot)],
        ['heldTasksBanner', 'isOpen', $set(isOpen)],
      ],
      state
    );
  },

  [ActionTypes.HANDLE_HELD_TASKS_BANNER_TOGGLE](state, { isOpen }) {
    return update(['heldTasksBanner', 'isOpen', $set(isOpen)], state);
  },

  [ActionTypes.CREATE_HELD_TASK_SNAPSHOT](state, { snapshot }) {
    const prevSnapshot = state.heldTasksBanner.snapshot;

    return update(
      [
        'heldTasksBanner',
        'snapshot',
        $set({
          staleAuthServiceNames: _.uniq([
            ...snapshot.staleAuthServiceNames,
            ...(prevSnapshot ? prevSnapshot.staleAuthServiceNames : []),
          ]),
          countsByHeldReason: {
            ...snapshot.countsByHeldReason,
            // Original snapshot takes precedence so we can check off completed steps
            ...(prevSnapshot ? prevSnapshot.countsByHeldReason : undefined),
          },
          totalHeldTaskCount:
            snapshot.totalHeldTaskCount >
            (prevSnapshot ? prevSnapshot.totalHeldTaskCount : 0)
              ? snapshot.totalHeldTaskCount
              : prevSnapshot.totalHeldTaskCount,
        }),
      ],
      state
    );
  },
};

export default createReducer(handlers, initialState);
